import moment from 'moment';
import React, { useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';

import { DownloadOutlined } from "@ant-design/icons";
import { Button, Divider, Table } from "antd";

import { CookieNameColumn, FirstAppearedScanColumn, LastAppearedScanColumn, PrevalenceColumn, VendorDetailsColumn, VendorNameColumn, VendorReferenceColumn, VendorStatusColumn, VendorTypeColumn } from "../../shared/DiagnoseColumns";

import { cookiesWithLongLifespansExport, getCookiesWithLongLifespansFilters, getCookiesWithLongLifespansList, getVendorManagementStatusesList } from "../../../../actions/diagnose_dashboard_actions";
import useTableDisplayConfig from '../../shared/useTableDispayConfig';
import useSearchParams from '../../shared/useSearchParams';
import { isFiltersProvided, mapSelectedFilters } from '../helpers';


const DetailedBreakdown = ({
                               getCookiesWithLongLifespansList,
                               cookiesWithLongLifespansList,
                               cookiesWithLongLifespansListPending,
                               cookiesWithLongLifespansFilter,
                               getCookiesWithLongLifespansFilters,
                               cookiesWithLongLifespansExportPending,
                               selectedFilters,
                               cookiesWithLongLifespansExport,
                               userDetails,
                               getVendorManagementStatusesList,
                               vendorManagementStatuses,
                               vendorManagementStatusesPending,
                               vendorManagementActivities
}) => {
    const { limit, page, orderBy, handleLimit, handlePageChange, handleOrder } = useTableDisplayConfig(10, 1, 'name_asc');
    const searchParams = useSearchParams();

    const [cookies, setCookies] = useState('');
    const [vendorNames, setVendorNames] = useState('');
    const [vendorTypes, setVendorTypes] = useState('');
    const [referenceVendors, setReferenceVendors] = useState('');
    const filters = useMemo(() => mapSelectedFilters(selectedFilters), [selectedFilters]);

    const [prevalenceRisk, setPrevalenceRisk] = useState([null, null]);
    //for Vendor Management
    const [metricDataWithStatuses, setMetricDataWithStatuses] = useState([]);

    const getCookiesWithLongLifespansListData = () => {
        getCookiesWithLongLifespansList({
            ...filters,
            page,
            limit,
            orderBy,
            prevalenceRisk,
            cookies,
            vendorNames,
            vendorTypes,
            referenceVendors,
            vendorId: searchParams?.vendor,
        });
    };

    const getVendorManagementStatusesListData = (vendors) => {
        getVendorManagementStatusesList({
            metric: "Cookies with long lifespans",
            vendors,
            websites: selectedFilters?.websites,
        });
    };

    const getCookiesWithLongLifespansFiltersData = () => {
        getCookiesWithLongLifespansFilters(filters);
    };

    useEffect(() => {
        if (isFiltersProvided(filters)) {
            getCookiesWithLongLifespansListData();
        }
    }, [
        filters,
        page,
        limit,
        orderBy,
        prevalenceRisk,
        cookies,
        vendorNames,
        vendorTypes,
        referenceVendors
    ]);

    useEffect(() => {
        if (isFiltersProvided(filters)) {
            getCookiesWithLongLifespansFiltersData();
        }
    }, [
        filters,
    ]);

    const getUniqueVendorIdsList = (detailMetricData) => {
        return [...new Set(detailMetricData.map(item => item.vendor_id))];
    };

    const addStatusesToMetricData = () => {
        const metricDataWithStatusesClone = _.cloneDeep(cookiesWithLongLifespansList?.results);
        metricDataWithStatusesClone.forEach((row) => {
            row.vendor_status = []
            vendorManagementStatuses.forEach(vendorStatus => {
                if(vendorStatus.vendor === row.vendor_id){
                    row.vendor_status.push(vendorStatus);
                }
            });
        });
        setMetricDataWithStatuses(metricDataWithStatusesClone);
    };

    useEffect(() => {
        if(cookiesWithLongLifespansList?.results?.length && userDetails.accountFeatures.includes('diagnose_vendor_management')){
            getVendorManagementStatusesListData(getUniqueVendorIdsList(cookiesWithLongLifespansList?.results));
        }
    }, [cookiesWithLongLifespansList]);

    useEffect(() => {
        if(vendorManagementStatuses && cookiesWithLongLifespansList?.results){
            addStatusesToMetricData();
        }

    }, [vendorManagementStatuses]);

    useEffect(() => {
        if(vendorManagementActivities?.length){
            getVendorManagementStatusesListData(getUniqueVendorIdsList(cookiesWithLongLifespansList?.results));
        }
    }, [vendorManagementActivities]);

    const vendorsFilter = cookiesWithLongLifespansFilter?.vendors?.map(filter => ({ text: filter, value: filter }));
    const cookiesFilter = cookiesWithLongLifespansFilter?.cookies?.map(filter => ({ text: filter, value: filter }));
    const referenceVendorsFilter = cookiesWithLongLifespansFilter?.reference_vendors?.map(filter => ({ text: filter, value: filter }));

    const columns = [
        VendorTypeColumn({}),
        VendorNameColumn({ filters: vendorsFilter || [] }),
        VendorStatusColumn({ searchParams }),
        CookieNameColumn({ filters: cookiesFilter || [] }),
        {
            title: 'Cookie Lifespan',
            dataIndex: 'cookie_lifespan',
            key: 'cookie_lifespan',
            sorter: (a, b) => a.cookie_lifespan.years - b.cookie_lifespan.years,
            sortDirections: ['descend', 'ascend'],
            render: (text, record) => (
                <div>
                    {text.years ? <span style={{ marginRight: '5px' }}>{text.years} {text.years > 1 ? 'years' : 'year'}</span> : null}
                    {text.months ? <span>{text.months} {text.months > 1 ? 'months' : 'month'}</span> : null}
                </div>
            )
        },
        // {
        //     title: 'Declared IAB Cookie Lifespan',
        //     dataIndex: 'iab_cookie_lifespan',
        //     key: 'iab_cookie_lifespan',
        // },
        // {
        //     title: () => {
        //         return (
        //             <div>
        //                 Declared Storage & Access
        //                 <Tooltip
        //                     title={() => {
        //                         return (
        //                             <div className="information-storage-tooltip" >
        //                                 For IAB vendors only
        //                                 <div className="information-storage-item" >
        //                                     <div className={'cookie-icon-container'}>
        //                                         <div className={'cookie-refresh-icon'}><ReloadOutlined /></div>
        //                                         <span><Image alt="Persistent cookies" src={cookieFilledIcon} preview={false} /></span>
        //                                     </div>
        //                                     <div className="information-storage-item-name">CookieRefresh</div>
        //                                 </div>
        //                                 <div className="information-storage-item">
        //                                     <div className={'cookie-icon-container'}>
        //                                         <div className={'uses-non-cookie-access-icon'}><CheckOutlined /></div>
        //                                         <span><Image alt="Persistent cookies" src={cookieFilledIcon} preview={false} /></span>
        //                                     </div>
        //                                     <div className="information-storage-item-name">usesNonCookiesAccess</div>
        //                                 </div>
        //                                 <div className="information-storage-item">
        //                                     <div className={'cookie-icon-container'}>
        //                                         <div className={'uses-cookies-icon'} />
        //                                         <span><Image alt="Persistent cookies" src={cookieFilledIcon} preview={false} /></span>
        //                                     </div>
        //                                     <div className="information-storage-item-name">usesCookies</div>
        //                                 </div>
        //                             </div>
        //                         )}
        //                     }
        //                     overlayClassName="information-storage-tooltip-overlay"
        //                 >
        //                     <InfoCircleFilled />
        //                 </Tooltip>
        //             </div>
        //         );
        //     },
        //     key: 'information_storage',
        //     filters: [
        //         { text: 'CookieRefresh', value: 'cookie_refresh' },
        //         { text: 'usesNonCookiesAccess', value: 'uses_non_cookies_access' },
        //         { text: 'usesCookies', value: 'uses_cookies' },
        //     ],
        //     render: (text, record) => {
        //         return (
        //             <>
        //                 <div className={'cookie-icon-container'}>
        //                     {record.cookie_refresh && <div className={'cookie-refresh-icon'}><ReloadOutlined /></div>}
        //                     {record.uses_non_cookies_access && <div className={'uses-non-cookie-access-icon'}><CheckOutlined /></div>}
        //                     {record.uses_cookies && <div className={'uses-cookies-icon'} />}
        //                     <span><Image alt="Persistent cookies" src={cookieFilledIcon} preview={false} /></span>
        //                 </div>
        //
        //             </>
        //         );
        //     },
        //     filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
        //         const onCheckStorageType = (checkedValues) => {
        //             setSelectedKeys(checkedValues);
        //         };
        //         return (
        //             <div className="information_storage_custom_filter">
        //                 <Checkbox.Group onChange={onCheckStorageType} value={selectedKeys}>
        //                     <Checkbox key={'cookie_refresh'} value={'cookie_refresh'}>CookieRefresh
        //                         <div className={'cookie-icon-container'}>
        //                             <div className={'cookie-refresh-icon'}><ReloadOutlined /></div>
        //                             <span><Image alt="Persistent cookies" src={cookieFilledIcon} preview={false} /></span>
        //                         </div>
        //                     </Checkbox>
        //                     <Checkbox key={'uses_non_cookies_access'} value={'uses_non_cookies_access'}>usesNonCookiesAccess
        //                         <div className={'cookie-icon-container'}>
        //                             <div className={'uses-non-cookie-access-icon'}><CheckOutlined /></div>
        //                             <span><Image alt="Persistent cookies" src={cookieFilledIcon} preview={false} /></span>
        //                         </div>
        //                     </Checkbox>
        //                     <Checkbox key={'uses_cookies'} value={'uses_cookies'}>usesCookies
        //                         <div className={'cookie-icon-container'}>
        //                             <div className={'uses-cookies-icon'} />
        //                             <span><Image alt="Persistent cookies" src={cookieFilledIcon} preview={false} /></span>
        //                         </div>
        //                     </Checkbox>
        //                 </Checkbox.Group>
        //                 <div className="ant-table-filter-dropdown-btns">
        //                     <Button onClick={() => clearFilters()}>Reset</Button>
        //                     <Button type="primary" onClick={() => confirm({ closeDropdown: true })}>OK</Button>
        //                 </div>
        //             </div>
        //         );
        //     },
        // },
        {
            ...PrevalenceColumn,
            dataIndex: 'cookie_prevalence',
            key: 'cookie_prevalence',
        },
        FirstAppearedScanColumn,
        LastAppearedScanColumn,
        VendorReferenceColumn({ filters: referenceVendorsFilter || [] }),
        VendorDetailsColumn({ metric: 'Cookies with long lifespans' }),
    ];

    const onTableChange = (pagination, filters, sorter, extra) => {
        handleLimit(pagination.pageSize);
        handleOrder(sorter);

        for (const filter in filters) {
            if(filters[filter]){
                filter === 'cookies' && setCookies(filters[filter].join(';'));
                filter === 'name' && setVendorNames(filters[filter].join(';'));
                filter === 'vendor_type' && setVendorTypes(filters[filter].join(';'));
                filter === 'cookie_prevalence' && setPrevalenceRisk([filters[filter][0], filters[filter][1]]);
                filter === 'reference_vendors' && setReferenceVendors(filters[filter].join(';'));
            } else {
                filter === 'cookies' && setCookies('');
                filter === 'name' && setVendorNames('');
                filter === 'vendor_type' && setVendorTypes('');
                filter === 'cookie_prevalence' && setPrevalenceRisk([null, null]);
                filter === 'reference_vendors' && setReferenceVendors('');
            }
        }
    };

    const onPaginationChange = (pageNumber, pageSize) => {
        handlePageChange(pageNumber);
    };

    const exportCsv = () => {
        cookiesWithLongLifespansExport(filters)
    };

    return (
        <div className={'detailed-breakdown-container'}>
            <div>The table below lists the vendors that we have observed on your properties
                that are dropping cookies with lifespans over 13 months in the period of time selected.</div>
            <Divider />
            <div className='detailed-breakdown-table-container'>
                <div className={ 'filters_block' } >
                    <div className={ 'quick_filters' }>
                        {/*<div>Quick Filters:</div>*/}
                        {/*<Button >*/}
                        {/*    High risk vendors*/}
                        {/*</Button>*/}
                        {/*<Button >*/}
                        {/*    Medium risk vendors*/}
                        {/*</Button>*/}
                        {/*<Button >*/}
                        {/*   Low risk vendors*/}
                        {/*</Button>*/}
                    </div>
                    <div className={ 'downloadCSV' }>
                        <Button icon={<DownloadOutlined />} onClick={exportCsv} loading={cookiesWithLongLifespansExportPending}/>
                    </div>
                </div>
                <Table
                    id="detailed-breakdown"
                    getPopupContainer={trigger => document.getElementById('detailed-breakdown')}
                    scroll={{ x: 'max-content', y: 430 }}
                    dataSource={userDetails.accountFeatures.includes('diagnose_vendor_management') ? metricDataWithStatuses : cookiesWithLongLifespansList?.results}
                    columns={userDetails.accountFeatures.includes('diagnose_vendor_management') ? columns : columns.filter(ea => ea.dataIndex !== "vendor_status") }
                    showSorterTooltip={false}
                    pagination={{ current: page, pageSize: limit, total: cookiesWithLongLifespansList?.total_count, position: ['bottomCenter'], onChange: onPaginationChange, defaultPageSize: 10, showSizeChanger: true, pageSizeOptions: ['10', '50', '100', '200'] }}
                    rowKey={(record) => record?.vendor_id}
                    rowClassName={(record) => (record.vendor_id === searchParams?.vendor && searchParams?.type === 'NEW_VENDOR' ? 'diagnose-notification-highlight' : '')}
                    onChange={onTableChange}
                    loading={{
                        className: "diagnose-spinning",
                        spinning: cookiesWithLongLifespansListPending || vendorManagementStatusesPending,
                        tip: cookiesWithLongLifespansList?.results?.length ? '' : 'Processing a large query; please wait or leave it open and check later.',
                        size: "large",
                      }}
                />
            </div>
        </div>
    );
};

const mapStateToProps = function (store) {
    return {
        cookiesWithLongLifespansList: store.diagnoseDashboardState.getIn(['cookiesWithLongLifespansList', 'value']),
        cookiesWithLongLifespansListPending: store.diagnoseDashboardState.get('cookiesWithLongLifespansListPending'),
        cookiesWithLongLifespansExportPending: store.diagnoseDashboardState.get('cookiesWithLongLifespansExportPending'),
        cookiesWithLongLifespansFilter: store.diagnoseDashboardState.getIn(['cookiesWithLongLifespansFilter', 'value']),
        selectedFilters: store.diagnoseDashboardState.getIn(['selectedFilters', 'value']),
        vendorManagementStatuses: store.diagnoseDashboardState.getIn(['vendorManagementStatuses', 'value']),
        vendorManagementStatusesPending: store.diagnoseDashboardState.get('vendorManagementStatusesPending'),
        vendorManagementActivities: store.diagnoseDashboardState.getIn(['vendorManagementActivities', 'value']),
        userDetails: store.accountState.getIn(["userDetails", "value"]),
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        getCookiesWithLongLifespansList,
        getCookiesWithLongLifespansFilters,
        cookiesWithLongLifespansExport,
        getVendorManagementStatusesList,
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(DetailedBreakdown);
